import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsTyperunsService } from './edit-dialogs-typeruns.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-typeruns',
  templateUrl: './edit-dialogs-typeruns.component.html',
  styleUrls: ['./edit-dialogs-typeruns.component.scss']
})
export class EditDialogsTyperunsComponent implements OnInit {

  /** Subscripción para el guardado de un parametro */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsTyperunsService: EditDialogsTyperunsService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsTyperunsComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsTyperunsService.build(); }

  ngOnInit() {
    this.editDialogsTyperunsService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Typeruns
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsTyperunsService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del typerun está ausente
      // -1: El número del typerun ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorTypeRuns('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorTypeRuns('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog typeruns
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let typerun = this.editDialogsTyperunsService.typeruns;
    let original = this.editDialogsTyperunsService.originalTyperuns;
    return this.editDialogsTyperunsService.compare(typerun, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorTypeRuns(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
